
import { defineComponent, onMounted, onUnmounted } from 'vue'
import $ from 'jquery'

export default defineComponent({
  emits: {
    dismiss: () => true
  },
  setup (_, { emit }) {
    onMounted(() => {
      $('body').addClass('modal-open')
    })

    onUnmounted(() => {
      $('body').removeClass('modal-open')
    })

    const dismiss = () => {
      emit('dismiss')
    }

    return {
      dismiss
    }
  }
})
